import React, { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./caretakerDash.scss";

//import context
import { MyContext } from "../tenantsDashContext";

//import  components
import TopSection from "../Other-Page-Components/Admin-Components/OverView/Mobile-and-Tablet/Top-Section-Mobile.jsx";
import TopSectionPc from "../Other-Page-Components/Admin-Components/OverView/Pc-and-Large-Screens/Top-Section-Pc.jsx";

//navigation
import MobileNav from "../Other-Page-Components/Admin-Components/OverView/Mobile-and-Tablet/Mobile-Nav.jsx";
import Navigation from "../Other-Page-Components/Admin-Components/OverView/Pc-and-Large-Screens/Dashboard.jsx";

import MiddleSectionOverview from "../Other-Page-Components/Admin-Components/OverView/Mobile-and-Tablet/Mid-section-Mobile.jsx";
import MiddleSectionPc from "../Other-Page-Components/Admin-Components/OverView/Pc-and-Large-Screens/Mid-section-Pc.jsx";

//right section
import RightSectionPc from "../Other-Page-Components/Admin-Components/OverView/Pc-and-Large-Screens/Right-Section.jsx";

//messaging components
import MobileChat from "../Other-Page-Components/Admin-Components/Messaging/Mobile-and-Tablet/Mid-Section.jsx";
import MessagingApp from "../Other-Page-Components/Admin-Components/Messaging/Pc-and-Large-Screens/Mid-Section-Pc.jsx";

//importing profile components
import MidSectionProfile from "../Other-Page-Components/Admin-Components/Profile/Mobile-and-Tablet/Mid-Section-Mobile.jsx";
import MidSectionProfilePc from "../Other-Page-Components/Admin-Components/Profile/Pc-and-Large-Screens/Mid-Section-Pc.jsx";

//payment components
import MidSectionPayments from "../Other-Page-Components/Admin-Components/Payments/Mobile-and-Tablet/Mid-Section.jsx";
import MidSectionPaymentsPc from "../Other-Page-Components/Admin-Components/Payments/Pc-and-Large-Screens/Mid-Section-Pc.jsx";
import MidSectionTenants from "../Other-Page-Components/Admin-Components/Tenants/Mobile-and-Tablet/Mid-Section-Mobile.jsx";
import MidSectionTenantsPc from "../Other-Page-Components/Admin-Components/Tenants/Pc-and-Large-Screens/Mid-Section-Pc.jsx";
import MidSectionProperties from "../Other-Page-Components/Admin-Components/Properties/Pc-and-Large-Screens/Mid-Section-Pc.jsx";
import MidSectionPropertiesMobile from "../Other-Page-Components/Admin-Components/Properties/Mobile-and-Tablet/Mid-Section.jsx";
import MidSectionExpensesPc from "../Other-Page-Components/Admin-Components/Expenses/Pc-and-Large-Screens/Mid-Section-Pc.jsx";
import MidSectionExpensesMobile from "../Other-Page-Components/Admin-Components/Expenses/Mobile-and-Tablet/Mid-Section-Mobile.jsx";
import MidSectionInvoicesPc from "../Other-Page-Components/Admin-Components/Invoices/Pc-and-Large-Screens/Mid-Section-Pc.jsx";
import MidSectionReportsPc from "../Other-Page-Components/Admin-Components/Reports/Pc-and-Large-Screens/Mid-Section-Pc.jsx";

const ROUTE_CATEGORY_MAP = {
  overview: "Overview",
  properties: "Properties",
  tenants: "Tenants",
  invoices: "Invoices",
  payments: "Payments",
  expenses: "Expenses",
  reports: "Reports",
  messages: "Messages",
  profile: "Profile",
};

const AdminDash = () => {
  const { sharedValue, setSharedValue } = useContext(MyContext);
  const navigate = useNavigate();
  const { category } = useParams();

  //  check  window size
  const [isMobileScreen, setIsMobileScreen] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobileScreen(window.innerWidth < 1024);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Keep dashboard state in sync with URL category (/auth/landlord/:category)
  useEffect(() => {
    const normalizedCategory = category?.toLowerCase();

    if (!normalizedCategory) {
      setSharedValue("Overview");
      navigate("/auth/landlord/overview", { replace: true });
      return;
    }

    const routeCategory = ROUTE_CATEGORY_MAP[normalizedCategory];

    if (!routeCategory) {
      setSharedValue("Overview");
      navigate("/auth/landlord/overview", { replace: true });
      return;
    }

    setSharedValue(routeCategory);
  }, [category, navigate, setSharedValue]);

  return (
    <div className="caretaker-dashboard">
      {isMobileScreen ? (
        <>
          {sharedValue === "Overview" && (
            <>
              <TopSection
                setSharedValue={setSharedValue}
                sharedValue={sharedValue}
              />
              <MiddleSectionOverview />
            </>
          )}

          {sharedValue === "Payments" && (
            <>
              <TopSection
                setSharedValue={setSharedValue}
                sharedValue={sharedValue}
              />
              <MidSectionPayments />
            </>
          )}
          {sharedValue === "Tenants" && (
            <>
              <TopSection
                setSharedValue={setSharedValue}
                sharedValue={sharedValue}
              />
              <MidSectionTenants />
            </>
          )}
          {sharedValue === "Properties" && (
            <>
              <TopSection
                setSharedValue={setSharedValue}
                sharedValue={sharedValue}
              />
              <MidSectionPropertiesMobile />
            </>
          )}

          {sharedValue === "Expenses" && (
            <>
              <TopSection
                setSharedValue={setSharedValue}
                sharedValue={sharedValue}
              />
              <MidSectionExpensesMobile />
            </>
          )}

          {sharedValue === "Messages" && (
            <>
              <MobileChat
                setSharedValue={setSharedValue}
                sharedValue={sharedValue}
              />
            </>
          )}

          {sharedValue === "Profile" && (
            <>
              <TopSection
                setSharedValue={setSharedValue}
                sharedValue={sharedValue}
              />
              <MidSectionProfile />
            </>
          )}

          <MobileNav />
        </>
      ) : (
        <>
          <div className="pc-container">
            <Navigation />
            <div className="right">
              <TopSectionPc />
              {sharedValue === "Overview" && (
                <>
                  <div className="mid-section">
                    <div className="mid-left">
                      <MiddleSectionPc />
                    </div>
                    <div className="mid-right">
                      <RightSectionPc />
                    </div>
                  </div>
                </>
              )}
              {sharedValue === "Tenants" && (
                <>
                  <MidSectionTenantsPc />
                </>
              )}
              {sharedValue === "Properties" && (
                <>
                  <MidSectionProperties />
                </>
              )}
              {sharedValue === "Payments" && (
                <>
                  <MidSectionPaymentsPc />
                </>
              )}
              {sharedValue === "Invoices" && (
                <>
                  <MidSectionInvoicesPc />
                </>
              )}
              {sharedValue === "Expenses" && (
                <>
                  <MidSectionExpensesPc />
                </>
              )}
              {sharedValue === "Reports" && (
                <>
                  <MidSectionReportsPc />
                </>
              )}

              {sharedValue === "Messages" && (
                <>
                  <MessagingApp />
                </>
              )}

              {sharedValue === "Profile" && (
                <>
                  <MidSectionProfilePc />
                </>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminDash;
